// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3iBPw","bigColWidth":"Table_bigColWidth__2SNCy","biggerColWidth":"Table_biggerColWidth__3IDNU","row":"Table_row__13Vd-","col":"Table_col__glW40"};